import { render } from "./StudentQuestionBonus.vue?vue&type=template&id=4c1faf84"
import script from "./StudentQuestionBonus.vue?vue&type=script&lang=js"
export * from "./StudentQuestionBonus.vue?vue&type=script&lang=js"

import "./StudentQuestionBonus.vue?vue&type=style&index=0&id=4c1faf84&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__